import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import axios from "axios";

const origin = window.location.origin;

export default class ProtectedRoute extends Component {

    state = {
        isAuth: false,
        toggle: false
    };

    login = () => {
        window.location.href = origin + "/login";
    };

    checkSession = () => {
        axios.get("/session").then(res => {
            if (res.status === 200 && res.data) {
                this.props.updateAuth(true);
            } else {
                console.log("session expired...");
                this.props.updateAuth(false);
                window.location.reload(true);
            }
        }).catch(err => {
            console.log("error getting session details --- " + err);
            this.props.updateAuth(false);
            window.location.reload(true);
        });
    };

    componentDidMount() {
        this.checkSession();
    }

    componentWillReceiveProps({prop}) {
        this.setState({...this.state, prop})
    }

    render() {

        const { exact, path, comp, isAuth } = this.props;

        if (!isAuth) {
            this.checkSession();
        }

        return (
            <Route exact={exact} path={path} render={props => comp} />
        )

    }

}
